var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ef-group" },
    [
      _c(
        "div",
        { staticClass: "ef-group-head" },
        [
          _c("b", [_vm._v(_vm._s(_vm.$ct(`field-type.${_vm.type}`)))]),
          _c("span", { staticClass: "ef-count" }, [
            _vm._v(
              _vm._s(
                _vm.$ct("used-of-max", {
                  used: _vm.usedIndexes.length,
                  max: _vm.maxCount,
                })
              )
            ),
          ]),
          _c("w-spacer"),
          _vm.freeIndexes.length > 0
            ? [
                _vm.usedIndexes.length > 0
                  ? _c(
                      "w-menu",
                      {
                        attrs: {
                          "close-on-blur": "",
                          "close-on-click": "",
                          right: "",
                        },
                        model: {
                          value: _vm.slotMenuOpen,
                          callback: function ($$v) {
                            _vm.slotMenuOpen = $$v
                          },
                          expression: "slotMenuOpen",
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("choose-free-slot"),
                                expression: "$ct('choose-free-slot')",
                              },
                            ],
                            staticClass: "ef-choose",
                            attrs: { slot: "activator" },
                            slot: "activator",
                          },
                          [_c("w-fa", { attrs: { icon: "ellipsis-h" } })],
                          1
                        ),
                        _c(
                          "w-transition-slide-height",
                          [
                            _vm.slotMenuOpen
                              ? _c(
                                  "w-scroll-view",
                                  {
                                    staticClass:
                                      "w-dropdown-select-items ef-slot-menu",
                                    attrs: {
                                      "rounded-bottom": "",
                                      "rounded-top": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ef-slot-menu-title" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$ct("choose-free-slot"))
                                        ),
                                      ]
                                    ),
                                    _vm._l(_vm.freeIndexes, function (i) {
                                      return _c(
                                        "div",
                                        {
                                          key: i,
                                          staticClass:
                                            "w-dropdown-select-item ef-slot-item",
                                          attrs: { tabindex: "0" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addIndex(i)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "ef-slot-key" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.keyPrefix) +
                                                  _vm._s(i)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _c("span", { staticClass: "ef-full" }, [
                _vm._v(
                  _vm._s(
                    _vm.$ct(`all-in-use.${_vm.type}`, { max: _vm.maxCount })
                  )
                ),
              ]),
        ],
        2
      ),
      _vm.visibleIndexes.length > 0
        ? _c(
            "w-sortable",
            {
              attrs: {
                items: _vm.visibleIndexes,
                "disable-x": "",
                "keep-in-y": "",
                "target-class": "handle",
              },
              on: {
                drop: function ($event) {
                  return _vm.onDrop()
                },
              },
            },
            _vm._l(_vm.visibleIndexes, function (index) {
              return _c("app-extra-field-row", {
                key: index,
                ref: "row" + index,
                refInFor: true,
                attrs: {
                  settings: _vm.settings,
                  type: _vm.type,
                  index: index,
                  "extra-fields-type": _vm.extraFieldsType,
                  autofocus: index == _vm.focusIndex,
                },
                on: {
                  clear: function ($event) {
                    return _vm.clearIndex(index)
                  },
                  enter: function ($event) {
                    return _vm.addFirstFree()
                  },
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm.freeIndexes.length > 0
        ? _c(
            "button",
            {
              staticClass: "ef-add",
              class: { dim: _vm.usedIndexes.length == 0 },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.addFirstFree()
                },
              },
            },
            [
              _c("w-fa", { attrs: { icon: "plus" } }),
              _vm._v(_vm._s(_vm.$ct(`add-field.${_vm.type}`)) + " "),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }